import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BookingDataService from "../../services/Booking";
import { Loader } from "../../components/Loader/Loader";
import { BookingLeftDetails } from "../../components/BookingView/BookingLeftDetails";
import { BookingRightDetails } from "../../components/BookingView/BookingRightDetails";
import { CartInformation } from "../../components/BookingView/CartInformation";
import { LeadInformation } from "../../components/BookingView/LeadInformation";
import { EmergencyContact } from "../../components/BookingView/EmergencyContact";
import { ExpertInformation } from "../../components/BookingView/ExpertInformation";
import { ManoshalaProInfo } from "../../components/BookingView/ManoshalaProInfo";
import { PaymentInformation } from "../../components/BookingView/PaymentInformation";
import { PhysicalAddress } from "../../components/BookingView/PhysicalAddress";
import { SubscriptionInfo } from "../../components/BookingView/SubscriptionInfo";
import { TherapyNote } from "../../components/BookingView/TherapyNote";

export const BookingView = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [row, setRow] = useState<any>();
  const { id } = useParams();

  const fetchData = () => {
    setIsLoading(true);
    BookingDataService.getSingleBooking(String(id))
      .then((res) => {
        const data = res.data;
        setRow(data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Bookings - View</div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="p-5">
          {/* <div className="row m-0 justify-content-between align-items-center">
            <div className="col-sm-8 p-lg-0">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => navigate(`/bookings/edit/${id}`)}
                >
                  Edit
                </button>
              </div>
            </div>
          </div> */}

          {row ? (
            <div className="main-section">
              <div className="row justify-content-center client-detail-sec ">
                <div className="col-sm-12 card px-5  p-3">
                  <div className="row justify-content-between">
                    <BookingLeftDetails {...row} />
                    <BookingRightDetails {...row} />
                  </div>
                  <div className="row justify-content-between">
                    <CartInformation {...row.cart_information} />
                    <LeadInformation {...row.lead_information} />
                  </div>
                  <div className="row justify-content-between">
                    <ManoshalaProInfo {...row.manoshala_pro} />
                    <PaymentInformation {...row.payment_information} />
                  </div>
                  <div className="row justify-content-between">
                    {row.therapy_note && <TherapyNote {...row.therapy_note} />}
                    <SubscriptionInfo {...row.subscription} />
                  </div>
                  <div className="row justify-content-between">
                    <PhysicalAddress {...row.physical_session_address} />
                    <ExpertInformation {...row.expert_information} />
                  </div>
                  <div className="row justify-content-between">
                    <EmergencyContact {...row.emergency_contact} />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};
